import src from "IMAGE";
export default { src, width: 655, height: 774, blurWidth: 0, blurHeight: 0};
